// ==============================|| OVERRIDES - CARD CONTENT ||============================== //

export default function CardContent() {
  return {
    MuiCardContent: {
      styleOverrides: {
        root: {
          padding: 30,
          '&:last-child': {
            paddingBottom: 30,
          },
        },
      },
    },
  };
}
